<div class="full-width py-3 px-4" fxLayout="column" fxLayoutAlign="start start">
  <div class="full-width" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="15px">
    <div class="full-width mb-0" fxLayout="row" fxLayoutAlign="end center">
      <button class="button-close-top" mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="title-default">Approve applicant</div>

    <div class="body-1-regular-2">
      Before approving, please select the company type. This affects the pricing rules that will be applied.
    </div>

    <form [formGroup]="form" class="full-width" fxLayout="column" fxLayoutGap="20px">
      <app-atoku-company-type-select
        formControlName="companyTypeCode"
        [credentials]="credentials"
        label="Company Type"
        placeholder="Select company type">
      </app-atoku-company-type-select>
    </form>

    <div class="full-width" fxLayout="row" fxLayoutAlign="end center" fxFlexOffset="10px">
      <button class="button-primary" mat-flat-button (click)="approve()" [disabled]="form.invalid">
        <mat-icon>check</mat-icon>
        <div class="button-text">Approve</div>
      </button>
    </div>
  </div>
</div>
